import { render } from "./PortalMisDatos.vue?vue&type=template&id=e24f14d8&scoped=true"
import script from "./PortalMisDatos.vue?vue&type=script&lang=js"
export * from "./PortalMisDatos.vue?vue&type=script&lang=js"

import "./PortalMisDatos.vue?vue&type=style&index=0&id=e24f14d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24f14d8"]])

export default __exports__